// Generated from ContestParticipant's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestParticipantCollectionFilterGroups
  = | {
    readonly contest: Iri
    readonly uploadId: string | string[]
    readonly started?: boolean | boolean[]
  }
  | {
    readonly contest: Iri
    readonly started: boolean | boolean[]
  }
  | {
    readonly contest: Iri
    readonly category?: Iri | Iri[]
    readonly search?: string | string[]
    readonly wave?: Iri
  }

export const contestParticipantCollectionFilterMapping: FilterDefinitionMapping<ContestParticipantCollectionFilterGroups> = {
  contest: 'contest',
  uploadId: 'uploadId',
  started: 'started',
  category: 'category',
  search: 'search',
  wave: 'wave',
}

export type ContestParticipantCollectionSort = 'lastName' | 'category.position' | 'wave.name' | 'bibNumber'
